import React from "react";
import util from 'lodash/util';

import { auth } from '../firebaseApp';
import firebase from 'firebase/app';

import firebaseui from 'firebaseui';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';

import GoogleAnalytics from '../Components/GoogleAnalytics';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';

import { withRouter } from "react-router";
import * as routes from '../Constants/routes';

import '../styles/firebaseui-styling.global.css';

// Styles
const styles = theme => ({
  root: {
    paddingTop: theme.spacing.unit * 1,
    flexGrow: 1,
  },

  firebaseUi : {
    minWidth: 250,
  },
});

class SignIn extends React.Component {
  
  uiConfig = {
    signInFlow: 'redirect',
    signInOptions: [      
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      firebase.auth.FacebookAuthProvider.PROVIDER_ID,
      {
        provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
        requireDisplayName: false,
      }
    ],
    credentialHelper: firebaseui.auth.CredentialHelper.NONE,
    callbacks: {
      signInSuccessWithAuthResult: (userCredential) =>  {
        
        let isNewUser = userCredential.additionalUserInfo && userCredential.additionalUserInfo.isNewUser;
        let provider = userCredential.additionalUserInfo && userCredential.additionalUserInfo.providerId;
        let eventAction = isNewUser ? GoogleAnalytics.CAAZAM_EVENTS.signUp : GoogleAnalytics.CAAZAM_EVENTS.signIn;
        let eventCategory = GoogleAnalytics.CATEGORY.user;
        GoogleAnalytics.event(eventCategory,eventAction,provider);

        this.props.history.push(routes.HOME);
        return false;
      }
    },
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Grid container spacing={8} align="center">
          <Grid item xs={12}>
            <Typography variant="title" >
              Caazam! Login
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <StyledFirebaseAuth uiCallback={ui => ui.disableAutoSignIn()} uiConfig={this.uiConfig} firebaseAuth={auth} className={classes.firebaseUi}/>
          </Grid>
        </Grid>
      </div>
    );
  }
}

var enhance = util.flowRight(
  withRouter,
  withStyles(styles)
);

export default enhance(SignIn);


// WEBPACK FOOTER //
// ./src/CaazamApp/SignIn.js